import { REFER_CREDIT_CENTS } from "@outschool/business-rules";
import { renderCurrencyString, useTranslation } from "@outschool/localization";
import {
  OutreachModal,
  OutreachModalType,
  SharingActivityType
} from "@outschool/ui-components-website";
import React from "react";

import PageModal from "../../PageModal";
import OutReachOrGive20Get20 from "../../sharing/OutReachOrGive20Get20";

export function Give20Get20ClassShare({
  shareLink,
  onClose,
  usesOutReachReferral,
  activity
}: {
  shareLink?: string;
  onClose: () => void;
  usesOutReachReferral?: boolean;
  activity?: SharingActivityType;
}) {
  const { t } = useTranslation("client\\routes\\ParentProfile");

  const onlyCreditAmount = renderCurrencyString({
    priceInCents: REFER_CREDIT_CENTS,
    showCurrencyCode: false
  });

  if (usesOutReachReferral) {
    return (
      <OutreachModal
        open={!!shareLink}
        onClose={onClose}
        outreachShareUrl={shareLink!}
        modalType={{
          variant: OutreachModalType.class,
          activity
        }}
      />
    );
  }

  return (
    <PageModal
      open={!!shareLink}
      onClose={onClose}
      fullBleed={false}
      sx={{ maxWidth: 450, padding: "medium" }}
    >
      <OutReachOrGive20Get20
        title={t(
          "Share this class with a friend - new users will get {{onlyCreditAmount}} off",
          {
            onlyCreditAmount
          }
        )}
        supportingCopy={t(
          "You’ll also get {{onlyCreditAmount}} when they sign up with your link and take their first class!",
          {
            onlyCreditAmount
          }
        )}
        link={shareLink || ""}
      />
    </PageModal>
  );
}
